import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';

import ASSETS from '../../assets';
import classNames from 'classnames';
import { bryt } from '../../http';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';
import { handleCopy, shortenString } from '../../utils';

dayjs.extend(utc);
dayjs.extend(relativeTime);

const TransactionDetails = () => {
  const txHash = useParams().id;

  const [tx, setTx] = useState(null);

  const [notFound, setNotFound] = useState(false);

  const [tab, setTab] = useState('overview');
  const handleTab = val => {
    setTab(val);
  };

  const handleGetTransaction = async () => {
    try {
      const transaction = await bryt.getTransactionByHash(txHash);
      setTx(transaction.result.transaction);
      console.log(transaction.result.transaction);
    } catch (err) {
      console.log(err.message);
      setNotFound(true);
    }
  };

  useEffect(() => {
    if (txHash) {
      handleGetTransaction();
    }
    // eslint-disable-next-line
  }, [txHash]);
  return (
    <>
      {notFound ? (
        <div className=' w-full h-full py-10 flex items-center justify-center flex-col gap-3'>
          <p className='text-[64px] font-bold text-bryt-primary-main'>404!</p>
          <p className='text-2xl text-bryt-primary-main'>
            The resource you requested was not found.
          </p>
        </div>
      ) : (
        <div className='flex-grow bg-blocks px-10 py-5'>
          <div className='flex items-center gap-3'>
            <p className='text-[19px] font-semibold'>Transaction Details</p>
            <div className='flex items-center gap-1'>
              {/* <div className='w-6 h-6 bg-bryt-grey-200 rounded-[6px] grid place-items-center cursor-pointer'>
                <img src={ASSETS.chevronLeft} alt='' />
              </div>
              <div className='w-6 h-6 bg-bryt-grey-200 rounded-[6px] grid place-items-center cursor-pointer'>
                <img src={ASSETS.chevronRight} alt='' />
              </div> */}
            </div>
          </div>
          <div className='border-t border-t-bryt-grey-200 mt-[19px]'></div>
          <p className='text-[14.5px] text-bryt-primary-main mt-[10px] mb-[30px]'>
            Use <span className='font-bold'>RYT SDK</span> for network
            communications
          </p>
          <div className='flex items-center gap-[10px]'>
            <button
              className={classNames(
                'py-[5px] px-[9px] bg-bryt-grey-200 rounded-lg text-bryt-primary-main',
                tab === 'overview' && 'text-white bg-bryt-primary-main'
              )}
              onClick={() => handleTab('overview')}
            >
              <p className='text-inherit text-[12.6px] font-semibold'>
                Overview
              </p>
            </button>
            {/* <button
              className={classNames(
                'py-[5px] px-[9px] bg-bryt-grey-200 rounded-lg text-bryt-primary-main',
                tab === 'state' && 'text-white bg-bryt-primary-main'
              )}
              onClick={() => handleTab('state')}
            >
              <p className='text-inherit text-[12.6px] font-semibold'>State</p>
            </button> */}
            {/* <div className='border border-bryt-grey-200 rounded-md h-[28px] px-[10px] cursor-pointer flex items-center gap-1'>
              <img src={ASSETS.checklist} alt='' />
              <img src={ASSETS.arrowDown} alt='' />
            </div> */}
          </div>
          <div className='bg-white px-[9px] py-5 border border-bryt-grey-200 rounded-[12px] shadow-txBox mt-3'>
            <div className='flex flex-col gap-[15px] px-2'>
              <div className='w-full grid grid-cols-12'>
                <div className='col-span-3 flex items-center gap-1'>
                  <img src={ASSETS.infoGrey} className='w-[14.5px]' alt='' />
                  <p className='text-[14.5px] text-bryt-grey-700'>
                    Transaction Hash:
                  </p>
                </div>
                <div className='col-span-9'>
                  <div className='flex items-center gap-1'>
                    <p className='text-[14.5px]'>{txHash}</p>
                    <img
                      src={ASSETS.copy}
                      className='cursor-pointer'
                      alt=''
                      onClick={() =>
                        handleCopy(txHash, 'Transaction Hash Copied')
                      }
                    />
                  </div>
                </div>
              </div>
              <div className='w-full grid grid-cols-12'>
                <div className='col-span-3 flex items-center gap-1'>
                  <img src={ASSETS.infoGrey} className='w-[14.5px]' alt='' />
                  <p className='text-[14.5px] text-bryt-grey-700'> Status:</p>
                </div>
                <div className='col-span-9 flex'>
                  <div className='flex items-center gap-1 border border-green-400 bg-green-100 px-2 py-[5px] rounded-[6px]'>
                    <img src={ASSETS.check} alt='' />
                    <p className='text-[11px] font-semibold text-bryt-green'>
                      Success
                    </p>
                  </div>
                </div>
              </div>
              <div className='w-full grid grid-cols-12'>
                <div className='col-span-3 flex items-center gap-1'>
                  <img src={ASSETS.infoGrey} className='w-[14.5px]' alt='' />
                  <p className='text-[14.5px] text-bryt-grey-700'>Block:</p>
                </div>
                <div className='col-span-9'>
                  <div className='flex items-center gap-2'>
                    <img src={ASSETS.hourGlass} alt='' />
                    <p className='text-[14.5px] text-bryt-primary-main'>
                      POM Block
                    </p>
                    {/* <div className='flex items-center gap-1 border border-bryt-grey-200 bg-bryt-grey-100 px-2 py-[5px] rounded-[6px]'>
                      <p className='text-[11px] font-semibold'>
                        0 Block Confirmations
                      </p>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className='w-full grid grid-cols-12'>
                <div className='col-span-3 flex items-center gap-1'>
                  <img src={ASSETS.infoGrey} className='w-[14.5px]' alt='' />
                  <p className='text-[14.5px] text-bryt-grey-700'>
                    {' '}
                    Timestamp:
                  </p>
                </div>
                <div className='col-span-9'>
                  <div className='flex items-center gap-1'>
                    <img src={ASSETS.clock} alt='' />
                    <p className='text-[14.5px]'>
                      {dayjs.utc(tx?.transaction_time).fromNow()} (
                      {tx?.transaction_time})
                    </p>
                  </div>
                </div>
              </div>
              <div className='border-t border-t-bryt-grey-200 my-[5px]'></div>
              <div className='w-full grid grid-cols-12'>
                <div className='col-span-3 flex items-center gap-1'>
                  <img src={ASSETS.volt} className='w-[14.5px]' alt='' />
                  <p className='text-[14.5px] text-bryt-grey-700'>
                    {' '}
                    Timestamp:
                  </p>
                </div>
                <div className='col-span-9'>
                  <div className='flex items-center gap-1'>
                    <img src={ASSETS.triangle} alt='' />

                    <p className='text-[14.5px]'>
                      <span className='text-bryt-grey-700'>Transfer</span>{' '}
                      {tx?.TransferObj?.value}{' '}
                      <span className='font-bold'>RYT</span>{' '}
                      <span className='text-bryt-grey-700'>To</span>{' '}
                      <Link to={`/accounts/${tx?.TransferObj?.to}`}>
                        <span
                          className='text-bryt-primary-main  break-words max-w-[50ch]'
                          style={{ wordWrap: 'break-word' }}
                        >
                          {tx?.TransferObj?.to.length > 50
                            ? shortenString(tx?.TransferObj?.to)
                            : tx?.TransferObj?.to}
                        </span>
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
              <div className='border-t border-t-bryt-grey-200 my-[5px]'></div>
              <div className='w-full grid grid-cols-12'>
                <div className='col-span-3 flex items-center gap-1'>
                  <img src={ASSETS.infoGrey} className='w-[14.5px]' alt='' />
                  <p className='text-[14.5px] text-bryt-grey-700'> From:</p>
                </div>
                <div className='col-span-9'>
                  <div className='flex items-center gap-1'>
                    <img src={ASSETS.rite} alt='' />
                    <p className='text-bryt-primary-main text-[14.5px]'>
                      <Link to={`/accounts/${tx?.TransferObj?.from}`}>
                        {tx?.TransferObj?.from}
                      </Link>
                    </p>
                    <img
                      src={ASSETS.copy}
                      className='cursor-pointer'
                      alt=''
                      onClick={() =>
                        handleCopy(
                          tx?.TransferObj?.from,
                          'Wallet address copied!'
                        )
                      }
                    />
                  </div>
                </div>
              </div>
              <div className='w-full grid grid-cols-12'>
                <div className='col-span-3 flex items-center gap-1'>
                  <img src={ASSETS.infoGrey} className='w-[14.5px]' alt='' />
                  <p className='text-[14.5px] text-bryt-grey-700'> To:</p>
                </div>
                <div className='col-span-9'>
                  <div className='flex items-center gap-1'>
                    <img src={ASSETS.draft} alt='' />
                    <p className='text-bryt-primary-main text-[14.5px]'>
                      <Link to={`/accounts/${tx?.TransferObj?.to}`}>
                        {tx?.TransferObj?.to.length > 50
                          ? shortenString(tx?.TransferObj?.to)
                          : tx?.TransferObj?.to}
                      </Link>
                    </p>
                    <img
                      src={ASSETS.copy}
                      alt=''
                      className='cursor-pointer'
                      onClick={() =>
                        handleCopy(
                          tx?.TransferObj?.to,
                          'Wallet address copied!'
                        )
                      }
                    />
                    <img src={ASSETS.check} alt='' />
                  </div>
                </div>
              </div>
              <div className='border-t border-t-bryt-grey-200 my-[5px]'></div>
              <div className='w-full grid grid-cols-12 px-2'>
                <div className='col-span-3 flex items-center gap-1'>
                  <img src={ASSETS.infoGrey} className='w-[14.5px]' alt='' />
                  <p className='text-[14.5px] text-bryt-grey-700'> Value:</p>
                </div>
                <div className='col-span-9'>
                  <p className='text-[14.5px]'>
                    {tx?.TransferObj?.value} RYT{' '}
                    <span className='text-bryt-grey-700'>($807.79)</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className='bg-white px-[9px] py-5 border border-bryt-grey-200 rounded-[12px] shadow-txBox mt-[14px]'>
            <div className='w-full grid grid-cols-12 px-2'>
              <div className='col-span-3 flex items-center gap-1'>
                <img src={ASSETS.infoGrey} className='w-[14.5px]' alt='' />
                <p className='text-[14.5px] text-bryt-grey-700'>
                  Private Note:
                </p>
              </div>
              <div className='col-span-9'>
                <p className='text-[14.5px]'>
                  To access the{' '}
                  <span className='font-semibold'>Private Note</span> feature,
                  you must be{' '}
                  <span className='text-bryt-primary-main'>Logged In</span>
                </p>
              </div>
            </div>
          </div>
          <div className='flex items-start gap-[14.5px] mt-[14px]'>
            <img src={ASSETS.bulb} alt='' />
            <p className='text-[12.5px] text-bryt-grey-700'>
              Blocks are batches of transactions linked via cryptographic
              hashes. Any tampering of a block would invalidate all following
              blocks as all subsequent hashes would change. Learn more about
              this page in our{' '}
              <span className='text-bryt-primary-main'>Knowledge Base</span>
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default TransactionDetails;
